import type { UniversalModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import { filterNulls } from "replo-utils/lib/array";

import ContentModifierComponent from "./base/ContentModifier";
import LinkModifierComponent from "./base/LinkModifier";
import PaddingModifierComponent from "./base/PaddingModifier";
import StyleModifier from "./base/StyleModifier";
import TextAlignmentModifierComponent from "./base/TextAlignmentModifier";
import TextColorModifierComponent from "./base/TextColorModifier";
import ModifierLayout from "./ModifierLayout";
import { useSelectedElementDesignations } from "./store/ModifiersStoreContext";

interface LinkModifierBlockProps {
  onModifiersValueChange: (
    modifiers: UniversalModifierValue[],
    stableElementId: string,
  ) => void;
}

const LinkModifierBlock: React.FC<LinkModifierBlockProps> = ({
  onModifiersValueChange,
}) => {
  const selectedElementDesignations = useSelectedElementDesignations();
  const defaultDesignation = selectedElementDesignations?.find(
    (designation) => designation.type === "default",
  );

  if (!defaultDesignation) {
    return null;
  }

  const linkDesignation = selectedElementDesignations?.find(
    (designation) => designation.type === "link",
  );

  const sections = filterNulls([
    linkDesignation
      ? {
          rows: [
            {
              title: "Link",
              component: (
                <LinkModifierComponent
                  onChange={(modifiers) => {
                    onModifiersValueChange(
                      modifiers,
                      linkDesignation.element.stableElementId,
                    );
                  }}
                />
              ),
            },
          ],
        }
      : null,
    {
      rows: [
        {
          title: "Content",
          component: (
            <ContentModifierComponent
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
        {
          title: "Alignment",
          component: (
            <TextAlignmentModifierComponent
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Style",
          component: (
            <StyleModifier
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
        {
          title: "Color",
          component: (
            <TextColorModifierComponent
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
      ],
    },
    {
      rows: [
        {
          title: "Padding",
          component: (
            <PaddingModifierComponent
              onChange={(modifiers) => {
                onModifiersValueChange(
                  modifiers,
                  defaultDesignation.element.stableElementId,
                );
              }}
            />
          ),
        },
      ],
    },
  ]);

  return (
    <ModifierLayout
      sections={sections}
      onModifiersValueChange={onModifiersValueChange}
    />
  );
};

export default LinkModifierBlock;
